// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"_93444fe79c--bannerWrapper--UrDyb"};